financeModule.factory('financeContractService', ['$q', 'commonRESTCallService', 'AppSettings', 'providerFeaturesService', 'imSessionVarsService',
    function($q, commonRESTCallService, AppSettings, providerFeaturesService, imSessionVarsService) {
        var financeContractSvc = {};

        // there is pretty much no need to ever clear this cache.
        // It should only change incredibly rarely, and only persists across a single session
        var urlCache = {};

        financeContractSvc.getFinancingContractBaseUrl = function() {
            var deferred = $q.defer();

            var providerId = imSessionVarsService.getCurrentProviderId();

            if(urlCache[providerId]) {
                deferred.resolve(urlCache[providerId]);
            } else {
                // retrieve url from IM - generally an external (not taillight) web page for entering banking information
                providerFeaturesService.getProviderApplicationSetting('alternate-financing-url')
                    .then(function(url) {
                        // set the cache
                        urlCache[providerId] = url;
                        deferred.resolve(urlCache[providerId]);
                    }, function(err) {
                        deferred.reject(err);
                    });
            }

            return deferred.promise;
        };

        financeContractSvc.getContractNumber = function(quoteId) {
            var deferred = $q.defer();

            //altfinance/financing-contract-number/?quoteId=NNNNN
            var url = new URI(AppSettings.startSPANPlusSvcURL)
                .segment(['altfinance', 'financing-contract-number'])
                .query({quoteId: quoteId});
            commonRESTCallService.getFromServer(url.toString())
                .success(function(data) {
                    // should just be a string value
                    deferred.resolve(data);
                })
                .error(function(err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        financeContractSvc.buildFinancingContractUrl = function(contractNumber) {
            var deferred = $q.defer();

            //financeContractSvc.getContractNumber(quoteId)
            //    .then(function(contractNumber) {
                    financeContractSvc.getFinancingContractBaseUrl()
                        .then(function(baseUrl) {
                            var url = new URI(baseUrl)
                                .query({docid: contractNumber});

                            deferred.resolve(url.toString());
                        }, function(err) {
                            deferred.reject(err);
                        });
              //  });

            return deferred.promise;
        };

        //financing-mode/:provider
        financeContractSvc.getAltFinancingMode = function() {
            var provider = imSessionVarsService.getCurrentProviderCode();
            var deferred = $q.defer();
            var url = new URI(AppSettings.startSPANPlusSvcURL)
                .segment(['altfinance', 'financing-mode', provider]);

            commonRESTCallService.getFromServer(url.toString())
                .success(function (responseData) {
                    deferred.resolve(responseData);
                }).error(function (err) {
                deferred.reject(err);
            });

            return deferred.promise;
        };

        //altfinance/check-alt-fin-status/:provider/:contractId/:quoteId
        financeContractSvc.getAltFinancingStatus = function(provider, contractId, quoteId) {
            var deferred = $q.defer();
            var providerName = imSessionVarsService.getCurrentProviderCode();

            var url = new URI(AppSettings.startSPANPlusSvcURL)
                .segment(['altfinance', 'check-alt-fin-status', providerName, ''+contractId, ''+quoteId]);

            commonRESTCallService.getFromServer(url.toString())
                .success(function(status) {
                    if (status.toString().toUpperCase() == "TRUE")
                        deferred.resolve(true);
                    else
                        deferred.resolve(false);
                })
                .error(function(status) {
                    deferred.reject(status);
                });

            return deferred.promise;
        };

        //updatespplink/:providerName/:contractId/:quoteid
        financeContractSvc.UpdateAltFinancingLink = function(contractId, quoteId) {
            var promiseWrapper = $q.defer();
            var providerName = imSessionVarsService.getCurrentProviderCode();
            var httpPromises = [];
            // for (var i=0; i < finalContractIds.length; i = i+1){
            var postUrl = AppSettings.startSPANPlusSvcURL + 'productcontracts/updatespplink/' + providerName + '/' + contractId + '/' + quoteId;
            httpPromises.push(
                commonRESTCallService.postToServer(postUrl, {})
            );
            // }

            $q.all(httpPromises)
                .then(
                    function(httpResponses){
                        promiseWrapper.resolve(httpResponses[0].data);
                    },
                    function(httpErrors){
                        promiseWrapper.reject(httpErrors[0]);
                    }
                )
            return promiseWrapper.promise;
        };

        return financeContractSvc;
    }
]);